<div class="banderole">
  <div class="card" (click)="navigation.media()">
    <img class="cardimage" src="assets/band.jpg">
    <div class="button">SOCIAL MEDIA</div>
  </div>
  <div class="card" (click)="navigation.album()">
    <img class="cardimage" src="assets/album_cover.jpg">
    <div class="button">ALBUM</div>
  </div>
  <div class="card" (click)="navigation.live()">
    <img class="cardimage" src="assets/justus.jpg">
    <div class="button">LIVE ON STAGE</div>
  </div>
</div>
